import React, { Fragment } from 'react';
import { Cell, Grid, Section } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';
import {
  FormSubmit,
  MarketoForm,
  Message,
  Input,
  PresetSelect,
  TextArea
} from '../../../../common/components/form-builder';
import './Forms.module.css';
import { useTranslation } from 'react-i18next';

const ResellerForm = ({}) => {
  const { t } = useTranslation();
  const formProps = {
    name: 'Become_a_Reseller',
    errorMessage: t(
      'There was an error submitting your request. Please try again!'
    ),
    successMessage: t(
      "Thank you for showing your interest in becoming a Formlabs Reseller. We'll be in touch shortly."
    ),
    trackingLabel: 'Become a Reseller Form Submitted',
    analyticsTrackMapping: { email: 'Email' },
    analyticsIdentifyMapping: {
      userId: 'Email',
      traits: { email: 'Email', firstName: 'FirstName', lastName: 'LastName' }
    },
    marketoOptions: {
      munchkinId: '060-UIG-504',
      baseUrl: 'https://app-sj15.marketo.com',
      formId: '1077'
    }
  };
  return (
    <Fragment>
      <MarketoForm {...formProps}>
        <Grid direction="x" gutters="padding">
          <Cell mediumSize={24}>
            <Header level={3} displayAs={3}>
              {t('Personal Information')}
            </Header>
          </Cell>
          <Cell mediumSize={12}>
            <Input
              maxLength="40"
              name="FirstName"
              required
              size="20"
              type="text"
              label={t('First name')}
            />
          </Cell>
          <Cell mediumSize={12}>
            <Input
              name="LastName"
              required
              type="text"
              label={t('Last name')}
            />
          </Cell>
          <Cell mediumSize={12}>
            <Input
              maxLength="80"
              name="Email"
              required
              type="email"
              label={t('Business email')}
            />
          </Cell>
          <Cell mediumSize={12}>
            <Input name="Title" required label={t('Job Title')} type="text" />
          </Cell>
        </Grid>
        <Section marginBefore="2rem">
          <Grid direction="x" gutters="padding">
            <Cell mediumSize={24}>
              <Header level={3} displayAs={3}>
                {t('Company Information')}
              </Header>
            </Cell>
            <Cell mediumSize={12}>
              <Input
                name="Company"
                required
                type="text"
                label={t('Company Name')}
              />
            </Cell>
            <Cell mediumSize={12}>
              <Input
                name="Website"
                required
                type="text"
                label={t('Company Website')}
              />
            </Cell>
            <Cell mediumSize={8}>
              <Input name="City" required type="text" label={t('City')} />
            </Cell>
            <Cell mediumSize={8}>
              <PresetSelect
                name="Country"
                secondaryName="State"
                label={t('Country')}
                type="countryAndUsState"
                isRequired
              />
            </Cell>
            <Cell mediumSize={8}>
              <PresetSelect
                name="NumberOfEmployees"
                label={t('Company Size')}
                type="companySize"
                isRequired
              />
            </Cell>

            <Cell mediumSize={24}>
              <TextArea
                name="What_geographic_region_s_do_you_serve__c"
                label={t('What geographic region(s) do you serve?')}
                aria-label={t('What geographic region(s) do you serve?')}
                required
                rows="3"
                type="text"
                wrap="soft"
              />
            </Cell>
          </Grid>
          <Grid direction="x" gutters="padding">
            <Cell mediumSize={24}>
              <Header level={3} displayAs={3}>
                {t('Application')}
              </Header>
            </Cell>

            <Cell mediumSize={12}>
              <TextArea
                name="Key_products_in_your_portfolio__c"
                required
                rows="3"
                type="text"
                wrap="soft"
                label={t('What are the key products in your portfolio?')}
                aria-label={t('What are the key products in your portfolio?')}
              />
            </Cell>
            <Cell mediumSize={12}>
              <TextArea
                name="Who_are_your_target_customers__c"
                required
                rows="3"
                type="text"
                wrap="soft"
                label={t('Who are your target customers?')}
                aria-label={t('Who are your target customers?')}
              />
            </Cell>
            <Cell mediumSize={12}>
              <TextArea
                name="Reason_to_resell_Formlabs_products__c"
                required
                rows="3"
                type="text"
                wrap="soft"
                label={t('Why do you want to resell Formlabs products?')}
                aria-label={t('Why do you want to resell Formlabs products?')}
              />
            </Cell>
            <Cell mediumSize={12}>
              <TextArea
                name="Anything_else_for_us_to_know__c"
                required
                rows="3"
                type="text"
                wrap="soft"
                label={t('Is there anything else you would like us to know?')}
                aria-label={t(
                  'Is there anything else you would like us to know?'
                )}
              />
            </Cell>
          </Grid>
        </Section>

        <Grid direction="x" gutters="margin">
          <Cell backgrounmediumSize={24}>
            <FormSubmit label="Submit" />
          </Cell>
          <Cell mediumSize={16} secondaryAlignment="align-self-middle">
            <Message type="error" />
            <Message type="success" />
          </Cell>
        </Grid>
      </MarketoForm>
    </Fragment>
  );
};

export default ResellerForm;
